// extracted by mini-css-extract-plugin
export default {"section":"StrategySection_section__dO6FI","modeRadioGroup":"StrategySection_modeRadioGroup__LcQIW","methodSelect":"StrategySection_methodSelect__kfsJd"};